<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Testbed User</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8; color: white" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="bProcessing?'disabled':''">
    <div *ngIf="bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Processing...
    </div>
    <form #pointForm="ngForm">
        <table class="edit-table table table-striped table-condensed">
            <thead>
            </thead>
            <tbody>
                <tr *ngIf="tmpPoint?._id">
                    <th>Point ID</th>
                    <td>{{tmpPoint?._id}}</td>
                </tr>
                <tr *ngIf="tmpPoint?._id">
                    <th>QR</th>
                    <td><app-point-qr-code pointId="{{tmpPoint?._id}}"></app-point-qr-code></td>
                </tr>
                <tr>
                    <th>Building ID</th>
                    <td>
                        <input  name="buildingId" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.buildingId" #buildingId="ngModel" required buildingId
                            [ngClass]="{ 'invalid-input': buildingId.invalid && (buildingId.dirty || buildingId.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Civic Address
                    <td>
                        <input  name="civicAddress" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.civicAddress" #civicAddress="ngModel" required
                            [ngClass]="{ 'invalid-input': civicAddress.invalid && (civicAddress.dirty || civicAddress.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Floor Num</th>
                    <td>
                        <input  id="floorNum" name="floorNum" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.floorNum" #floorNum="ngModel" required
                            [ngClass]="{ 'invalid-input': floorNum.invalid && (floorNum.dirty || floorNum.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Floor Name</th>
                    <td>
                        <input  id="floorName" name="floorName" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.floorName" #floorName="ngModel" required
                            [ngClass]="{ 'invalid-input': floorName.invalid && (floorName.dirty || floorName.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Dist From Window</th>
                    <td>
                        <input name="distFromWindow" class="form-control w-100"
                        [(ngModel)]="tmpPoint.distFromWindow" #distFromWindow="ngModel" required
                        [ngClass]="{ 'invalid-input': distFromWindow.invalid && (distFromWindow.dirty || distFromWindow.touched)}"
                        >
                    </td>
                </tr>
                <tr>
                    <th>Floor Description
                    <td>
                        <input  name="floorAndDescript" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.floorAndDescript" #floorAndDescript="ngModel" required
                            [ngClass]="{ 'invalid-input': floorAndDescript.invalid && (floorAndDescript.dirty || floorAndDescript.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Location Description</th>
                    <td>
                        <textarea name="locationDescription" rows="4" class="form-control" style="resize: none"
                        [(ngModel)]="tmpPoint.locationDescription" #locationDescription="ngModel" 
                        [ngClass]="{ 'invalid-input': locationDescription.invalid && (locationDescription.dirty || locationDescription.touched)}"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>WRef1</th>
                    <td>
                        <input  name="wRef1" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.wRef1" #wRef1="ngModel" required wRef1
                            [ngClass]="{ 'invalid-input': wRef1.invalid && (wRef1.dirty || wRef1.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>WRef2</th>
                    <td>
                        <input  id="wRef2" name="wRef2" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.wRef2" #wRef2="ngModel" required
                            [ngClass]="{ 'invalid-input': wRef2.invalid && (wRef2.dirty || wRef2.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Latitude</th>
                    <td>
                        <input  name="latitude" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.latitude" #latitude="ngModel" required latitude
                            [ngClass]="{ 'invalid-input': latitude.invalid && (latitude.dirty || latitude.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Longitude
                    <td>
                        <input  name="longitude" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.longitude" #longitude="ngModel" required
                            [ngClass]="{ 'invalid-input': longitude.invalid && (longitude.dirty || longitude.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Geo ID</th>
                    <td>
                        <input  id="geoid" name="geoid" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.geoid" #geoid="ngModel" required
                            [ngClass]="{ 'invalid-input': geoid.invalid && (geoid.dirty || geoid.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Altitude Geo ID Meters</th>
                    <td>
                        <input  name="altitudeGeoidMeters" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.altitudeGeoidMeters" #altitudeGeoidMeters="ngModel" required altitudeGeoidMeters
                            [ngClass]="{ 'invalid-input': altitudeGeoidMeters.invalid && (altitudeGeoidMeters.dirty || altitudeGeoidMeters.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Wgs84
                    <td>
                        <input  name="wgs84" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.wgs84" #wgs84="ngModel" required
                            [ngClass]="{ 'invalid-input': wgs84.invalid && (wgs84.dirty || wgs84.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Altitude Ellipsoid Meters</th>
                    <td>
                        <input  id="altitudeEllipsoidMeters" name="altitudeEllipsoidMeters" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.altitudeEllipsoidMeters" #altitudeEllipsoidMeters="ngModel" required
                            [ngClass]="{ 'invalid-input': altitudeEllipsoidMeters.invalid && (altitudeEllipsoidMeters.dirty || altitudeEllipsoidMeters.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Window Cnt</th>
                    <td>
                        <input  id="windowCnt" name="windowCnt" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.windowCnt" #windowCnt="ngModel" required
                            [ngClass]="{ 'invalid-input': windowCnt.invalid && (windowCnt.dirty || windowCnt.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Floor To Ceiling FtIn</th>
                    <td>
                        <input  name="floorToCeilingFtIn" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.floorToCeilingFtIn" #floorToCeilingFtIn="ngModel" required floorToCeilingFtIn
                            [ngClass]="{ 'invalid-input': floorToCeilingFtIn.invalid && (floorToCeilingFtIn.dirty || floorToCeilingFtIn.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Clutter
                    <td>
                        <input  name="clutter" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.clutter" #clutter="ngModel" required
                            [ngClass]="{ 'invalid-input': clutter.invalid && (clutter.dirty || clutter.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Hvac</th>
                    <td>
                        <input  id="hvac" name="hvac" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.hvac" #hvac="ngModel" required
                            [ngClass]="{ 'invalid-input': hvac.invalid && (hvac.dirty || hvac.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Quadrant</th>
                    <td>
                        <input  id="quadrant" name="quadrant" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.quadrant" #quadrant="ngModel" required
                            [ngClass]="{ 'invalid-input': quadrant.invalid && (quadrant.dirty || quadrant.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Stage1</th>
                    <td>
                        <input  name="stage1" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage1" #stage1="ngModel" required stage1
                            [ngClass]="{ 'invalid-input': stage1.invalid && (stage1.dirty || stage1.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Stage2
                    <td>
                        <input  name="stage2" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage2" #stage2="ngModel" required
                            [ngClass]="{ 'invalid-input': stage2.invalid && (stage2.dirty || stage2.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Stage1a</th>
                    <td>
                        <input  id="stage1a" name="stage1a" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage1a" #stage1a="ngModel" required
                            [ngClass]="{ 'invalid-input': stage1a.invalid && (stage1a.dirty || stage1a.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Stage1b2a</th>
                    <td>
                        <input  name="stage1b2a" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage1b2a" #stage1b2a="ngModel" required stage1b2a
                            [ngClass]="{ 'invalid-input': stage1b2a.invalid && (stage1b2a.dirty || stage1b2a.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>StageDl
                    <td>
                        <input  name="stageDl" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stageDl" #stageDl="ngModel" required
                            [ngClass]="{ 'invalid-input': stageDl.invalid && (stageDl.dirty || stageDl.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>StageZ</th>
                    <td>
                        <input  id="stageZ" name="stageZ" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stageZ" #stageZ="ngModel" required
                            [ngClass]="{ 'invalid-input': stageZ.invalid && (stageZ.dirty || stageZ.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Stage1c</th>
                    <td>
                        <input  id="stage1c" name="stage1c" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage1c" #stage1c="ngModel" required
                            [ngClass]="{ 'invalid-input': stage1c.invalid && (stage1c.dirty || stage1c.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>StageZa</th>
                    <td>
                        <input  name="stageZa" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stageZa" #stageZa="ngModel" required stageZa
                            [ngClass]="{ 'invalid-input': stageZa.invalid && (stageZa.dirty || stageZa.touched)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Stage1d
                    <td>
                        <input  name="stage1d" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage1d" #stage1d="ngModel" required
                            [ngClass]="{ 'invalid-input': stage1d.invalid && (stage1d.dirty || stage1d.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Stage1eZb</th>
                    <td>
                        <input  id="stage1eZb" name="stage1eZb" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.stage1eZb" #stage1eZb="ngModel" required
                            [ngClass]="{ 'invalid-input': stage1eZb.invalid && (stage1eZb.dirty || stage1eZb.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Type</th>
                    <td>
                        <input  id="type" name="type" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.type" #type="ngModel" required
                            [ngClass]="{ 'invalid-input': type.invalid && (type.dirty || type.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Class</th>
                    <td>
                        <input  name="class" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.class" #class="ngModel" required class
                            [ngClass]="{ 'invalid-input': class.status && (class.status || class.status)}"    
                        >
                    </td>
                </tr>
                <tr>
                    <th>Usability
                    <td>
                        <input  name="usability" type='text' class="form-control w-100"
                            [(ngModel)]="tmpPoint.usability" #usability="ngModel" required
                            [ngClass]="{ 'invalid-input': usability.invalid && (usability.dirty || usability.touched)}" >
                    </td>
                </tr>
                <tr>
                    <th>Comments</th>
                    <td>
                        <textarea name="comments" rows="4" class="form-control" style="resize: none"
                        [(ngModel)]="tmpPoint.comments" #comments="ngModel" 
                        [ngClass]="{ 'invalid-input': comments.invalid && (comments.dirty || comments.touched)}"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>Deleted</th>
                    <td>
                        <input id="deleted" name="deleted" type='checkbox' class="form-control move-left"
                            [(ngModel)]="tmpPoint.deleted" #deleted="ngModel"
                            [ngClass]="{ 'invalid-input': deleted.invalid && (deleted.dirty || deleted.touched)}" >
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </form>
</div>

<div class="modal-footer">
    <button [disabled]="bProcessing || !pointForm.dirty || pointForm.invalid" (click)="onSave()" class="btn btn-primary">Save</button>
    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
</div>
